import { Box } from '@material-ui/core';
import React from 'react';
import RexrothGIF from '../../../assets/media/rexroth.gif';
import { useMqXS } from '../../../utils/Utils';
import LoginButton from '../NavMenu/LoginButton/LoginButton';
import { openLicenseFile } from '../../../license/license';
import CopyrightIcon from '@material-ui/icons/Copyright';



const NavLogo = () => {

    const mq_xs = useMqXS();

    return (
        <>
            <Box ml={'auto'} display={'flex'} alignItems={'center'}>
                {/* LICENSE */}


                <div style={{ marginRight: '20px', cursor: 'pointer', zIndex: '2000' }} onClick={openLicenseFile}>

                    <CopyrightIcon color='primary' />
                </div>
                <Box mr={!mq_xs ? 2 : 0}>
                    <LoginButton />
                </Box>
                {!mq_xs
                    ? <img
                        src={RexrothGIF}
                        height={48}
                        alt="Rexroth"
                    />
                    : null
                }
            </Box>
        </>
    );
};

export default NavLogo;